import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { ProjectState } from 'store/Project/ProjectTypes'
import { setBoMItemOpen } from './setBoMItemOpen'

export const setSearchedBomItem: CaseReducer<
  ProjectState,
  PayloadAction<string>
> = (state, action) => {
  state.searchedBomItemId = action.payload
}

export const setSearchedBomItemByRowNumber: CaseReducer<
  ProjectState,
  PayloadAction<{ rowNumber: number; searchInTreeView?: boolean }>
> = (state, action) => {
  const flatViewOrTreeViewItems = action.payload.searchInTreeView
    ? state.treeView
    : state.flatView

  const partType = Object.values(flatViewOrTreeViewItems).find(
    (x) => x.type === 'Row' && x.rowNumber === action.payload.rowNumber
  ) as PartTypeRow

  if (partType) {
    state.searchedBomItemId = partType.id
    setBoMItemOpen(state, {
      payload: {
        bomItemId: partType.id,
        isOpen: true,
        preferTreeView: action.payload.searchInTreeView,
      },
      type: 'SET_BOM_ITEM_OPEN',
    })
  }
}
